import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
export function Testimonials() {
  const {
    t
  } = useLanguage();
  const [featured, ...rest] = t.testimonials.items;
  return <section aria-labelledby="testimonials-title" className="bg-stone py-24 md:py-32" data-id="element-359" data-mp="3fze09nroelqx">
      <div className="mx-auto max-w-7xl px-6 md:px-10" data-id="element-360" data-mp="3b0kr27jf9gwk">
        <h2 id="testimonials-title" className="font-display text-[30px] font-medium tracking-[-0.01em] text-ink md:text-[36px]" data-id="element-361" data-mp="3b01ez7ggdmqg">
          {t.testimonials.title}
        </h2>

        <div className="mt-14 grid gap-10 lg:grid-cols-12 lg:gap-16" data-id="element-362" data-mp="31yl4z0tjvmmr">
          <figure className="flex flex-col rounded-[28px] bg-white p-9 md:p-14 lg:col-span-7" data-id="element-363" data-mp="2x1upaelnqt1v">
            <span aria-hidden="true" className="font-serif text-[64px] leading-none text-violet" data-id="element-364" data-mp="2s2rx3uqs0hbb">
              “
            </span>
            <blockquote className="mt-2 font-serif text-[24px] leading-[1.45] text-ink md:text-[30px]" data-id="element-365" data-mp="v8ncbbtionj5">
              {featured.quote}
            </blockquote>
            <figcaption className="mt-auto pt-10" data-id="element-366" data-mp="h5oppb22s67f">
              <Author name={featured.name} context={featured.context} data-id="element-367" data-mp="h814jfcje0g9" />
            </figcaption>
          </figure>

          <div className="flex flex-col divide-y divide-line lg:col-span-5" data-id="element-368" data-mp="77s8c1ijof0v">
            {rest.map(item => <figure key={item.name} className="py-8 first:pt-0 last:pb-0" data-id="element-369" data-mp="c6btw0t87osp">
                <blockquote className="font-serif text-[19px] leading-[1.55] text-ink" data-id="element-370" data-mp="c8oiuxxeizf9">
                  “{item.quote}”
                </blockquote>
                <figcaption className="mt-5" data-id="element-371" data-mp="14u7nuxrev2ls">
                  <Author name={item.name} context={item.context} data-id="element-372" data-mp="14xdguo35uoms" />
                </figcaption>
              </figure>)}
          </div>
        </div>
      </div>
    </section>;
}
function Author({
  name,
  context
}: {
  name: string;
  context: string;
}) {
  const initials = name.split(' ').map(n => n[0]).join('').slice(0, 2);
  return <div className="flex items-center gap-4" data-id="element-373" data-mp="1nnlfasvx0qwn">
      <span aria-hidden="true" className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-violet-soft font-display text-[13px] font-semibold text-violet-deep" data-id="element-374" data-mp="1xhqvri8pngqu">
        {initials}
      </span>
      <div className="leading-tight" data-id="element-375" data-mp="1ofzr8gpwpfyk">
        <p className="text-[15px] font-semibold text-ink" data-id="element-376" data-mp="1oj5h3y6d0lvc">{name}</p>
        <p className="mt-1 text-[14px] text-muted" data-id="element-377" data-mp="1jhpwg783ghdh">{context}</p>
      </div>
    </div>;
}